import { observer } from 'mobx-react-lite'
import { RowContent } from 'components/ModalsContainer/v1Modals/PatientSummary/common'
import PendingVisit from 'models/Provider/visits/PendingVisit'

type ObservationProps = {
  visit: PendingVisit
}

const Observation = ({ visit }: ObservationProps) => {
  if (!visit || !visit.memberExtendedData) {
    return null
  }

  const { medicalHistory } = visit.memberExtendedData.privateData.member

  if (!medicalHistory) {
    return null
  }

  const observationRows = [
    {
      label: 'height',
      content: `${medicalHistory.heightFt}.${medicalHistory.heightIn}`,
    },
    {
      label: 'weight',
      content: medicalHistory.weightLbs,
    },
  ]
  const isAnyObservationDataProvided = observationRows.some((row) => row.content)

  if (!isAnyObservationDataProvided) return null
  return (
    <>
      <h6 className="typography-body-xl text-primary-800 font-medium mb-4">Observation</h6>
      {observationRows.map(
        ({ label, content }) => content && <RowContent label={label} content={content} className="mb-6" key={label} />,
      )}
    </>
  )
}

export default observer(Observation)
